module.exports = (__webpack_require__(12))(23);


//////////////////
// WEBPACK FOOTER
// delegated ./plugins/large_image/web_client/models/AnnotationModel.js from dll-reference girder_plugin_large_image
// module id = 23
// module chunks = 0